module.exports = __webpack_public_path__ + "assets/img/newlogo.2c20e9d2.png";